import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchBusinessesTypes = getApiActionTypes('FETCH_BUSINESSES');
export const createBusinessTypes = getApiActionTypes('CREATE_BUSINESS');
export const updateBusinessTypes = getApiActionTypes('UPDATE_BUSINESS');
export const deleteBusinessTypes = getApiActionTypes('DELETE_BUSINESS');
